 <div class="left">
    <ion-skeleton-text animated class="icon"></ion-skeleton-text>
    <div class="description">
        <div class="big"><ion-skeleton-text animated></ion-skeleton-text></div>
        <div class="small primary-color"><ion-skeleton-text animated></ion-skeleton-text></div>
    </div>
</div>
<ion-skeleton-text animated class="arrow"></ion-skeleton-text>
